import React, { useCallback } from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderStatus from "@/enum/OrderStatus";
import DropShippingProcessingStatus from "@/enum/dropShipping/DropShippingProcessingStatus";
import OrderStatusNameMap from "@/map/OrderStatusNameMap";
import PayOrderButton from "./components/PayOrderButton";
import DropShippingRefundStatus from "@/enum/DropShippingRefundStatus";
import DropShippingRefundStatusNameMap from "@/map/DropShippingRefundStatusNameMap";
import { observer } from "mobx-react-lite";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import DummySupplierIcon from "@/components/DummySupplierIcon";
import { SupplierType } from "@/dto/partnership/PartnershipDTO";

interface SupplierOrderInfoColumnProps {
    order: OrderDTO;
}

/**
 * 代理商查看供货商订单信息表格列
 */
const SupplierOrderInfoColumn: React.FC<SupplierOrderInfoColumnProps> = function (props) {
    const { order } = props;
    const orderManagementStore = useOrderManagementStore();

    // 支付完成后刷新状态
    const onRefresh = useCallback(() => {
        if (order) {
            const { id, retailerDropShippingInfo } = order;

            if (id && retailerDropShippingInfo) {
                orderManagementStore.table.updateOrder(id, {
                    retailerDropShippingInfo: {
                        ...retailerDropShippingInfo,
                        orderStatus: OrderStatus.PENDING_SHIPMENT,
                        processingStatus: DropShippingProcessingStatus.PENDING_APPROVAL,
                    },
                });
            }
        }
    }, [order]);

    const info = order?.retailerDropShippingInfo;

    // 只有没有提交过订单并且为等待发货状态才显示提交订单
    if (!info) {
        return <td />;
    }

    const dateCreated = info?.dateCreated;

    let statusColor = "#FAA706";
    let statusName = OrderStatusNameMap[info?.orderStatus];

    if (info?.refundStatus === DropShippingRefundStatus.PENDING_REFUND) {
        statusName = DropShippingRefundStatusNameMap[info.refundStatus];

        statusColor = "#FF4D4F";
    }

    // 是否付款
    const isPendingPayment = info?.orderStatus === OrderStatus.PENDING_PAYMENT;

    const otherComponents = (
        <>
            {isPendingPayment ? (
                <p className="pending-payment" style={{ color: "#A30014" }}>
                    <span className="mr10">未付款</span>

                    <PayOrderButton order={order} onSuccess={onRefresh} />
                </p>
            ) : (
                <p className="processing-status" style={{ color: statusColor }}>
                    {statusName}
                </p>
            )}
        </>
    );

    const supplierShopId = info?.supplierShopId;
    const partnership = orderManagementStore.retailerPartnershipsStore.supplierPartnershipMap.get(supplierShopId);

    return (
        <td className="ec-order-drop-shipping-info-column">
            {otherComponents}

            {partnership ? (
                <p>
                    <span>供货商:{partnership.alias || partnership.name}</span>
                    {partnership.type === SupplierType.DUMMY_SUPPLIER ? <DummySupplierIcon /> : null}
                </p>
            ) : null}

            <p className="retailer-supplier-order-id">订单编号: {props.order?.originalId}</p>

            {dateCreated ? <p className="created-time">提交时间: {dateCreated}</p> : null}
        </td>
    );
};

export default observer(SupplierOrderInfoColumn);
